import React from 'react';

import {
  BaseTier1ReturnAuthorizationModal,
  selectFields
} from 'modules/layer01';
import {
  errorUtil,
  fields
} from 'iron-forge-react-modules';

import { useForm } from 'react-hook-form';
import * as types from './types';
import * as ds from './dataService';



const ControlledCheckboxField = fields.CheckboxField.genControllerComponent<types.IFormState>();



export type QualityControlModalProps = {
  returnAuthorizationId: string;
  storeId: string;

  onClose: () => void;
};

export const FC = (props: QualityControlModalProps) => {
  const [
    submitQualityControlCheck,
    submitQualityControlCheckTuple
  ] = ds.useSubmitQualityControlCheck(props.returnAuthorizationId);
  const { genController } = selectFields.SoftwareVersionSelectField.genComponentAndControllerGenerator(props.storeId);
  const ControlledSoftwareVersionSelectField = genController<types.IFormState>();

  const form = useForm<types.IFormState>({});

  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      if (
        !formState.hasBeenResetAndDataCleared ||
        !formState.meetsCosmeticRequirements ||
        !formState.passedAllFunctionChecks
      ) {
        window.alert("All requirements must be satisfied before continuing to the next step.");
        return;
      }

      await errorUtil.errorWrap(async () => {
        await submitQualityControlCheck(formState);
        props.onClose();
      });
    },
    [
      props,
      submitQualityControlCheck
    ]
  );

  return (
    <BaseTier1ReturnAuthorizationModal.FC
      title="Quality Control Check"
      primaryText="Quality control check"
      secondaryText="Specify the software version and whether all checks have been completed."
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}
      disableButtons={submitQualityControlCheckTuple.loading}
      onBack={props.onClose}>

      <ControlledSoftwareVersionSelectField
        isDisabled={submitQualityControlCheckTuple.loading}
        formControl={form.control}
        fieldKey="softwareVersion"
        label="Software Version"
        isRequired />

      <ControlledCheckboxField
        isDisabled={submitQualityControlCheckTuple.loading}
        formControl={form.control}
        fieldKey="meetsCosmeticRequirements"
        label="Meets customer cosmetic requirements" />

      <ControlledCheckboxField
        isDisabled={submitQualityControlCheckTuple.loading}
        formControl={form.control}
        fieldKey="hasBeenResetAndDataCleared"
        label="Device has been reset and all data cleared" />

      <ControlledCheckboxField
        isDisabled={submitQualityControlCheckTuple.loading}
        formControl={form.control}
        fieldKey="passedAllFunctionChecks"
        label="Device passes all function tests" />

    </BaseTier1ReturnAuthorizationModal.FC>
  );
};
